export default __webpack_public_path__ + "static/no-image-8dd135278a006d79616d91f2aa96450f.png";